<template>
  <div class="frame-wrapper">
    <div
      class="frame"
      :style="background && (solid ? `background-color: ${background}` :`background-image: linear-gradient(135deg, ${background}, transparent 44%)`)"
    >
      <slot class="slot"></slot>
    </div>
    <h2 v-if="title" class="title">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: "Frame",
  props: {
    title: String,
    background: String,
    solid: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
.frame-wrapper {
  height: 100%;
  position: relative;
  width: 100%;
  border-radius: inherit;
  font-weight: bold;
}

.frame {
  background: #263238;
  background: var(--color-secondary);
  height: 100%;
  overflow: hidden;
  border-top: 2.5rem solid #37474f;
  border-top: 2.5rem solid var(--color-tertiary);
  height: 100%;
  border-radius: inherit;
}

.title {
  position: absolute;
  top: 0;
  left: 1.2rem;
  font-size: 2rem;
}
</style>
